import { useRoles } from "./useRoles";
import {
  useCommonAuthSelfRetrieveQuery,
  useCommonCmpasModuleListQuery,
} from "@app/api/carApi.generated";
import { CARAVEL_FIRM_ID } from "@app/pages/settings/useUser";
import { useMemo } from "react";
import { debugLog } from "@app/utils";
import { usePageTree } from "./usePageTree";

export enum CarModuleSectionCode {
  "CMPAS_HOME" = "CMPAS_HOME",
  "CMPAS_LOGIN" = "CMPAS_LOGIN",
  "CMPAS_PAYMENT" = "CMPAS_PAYMENT",
  "CMPAS_PAYMENT_COMPLETE" = "CMPAS_PAYMENT_COMPLETE",
  "CMPAS_RESET_PASSWORD" = "CMPAS_RESET_PASSWORD",
  "CMPAS_ACCEPT_INVITATION" = "CMPAS_ACCEPT_INVITATION",

  "SIMULATION" = "SIMULATION",
  /**/ "SIMULATION_STATIC" = "SIMULATION_STATIC",
  /*    */ "SIMULATION_ANALYSIS_STATIC_SUMMARY" = "SIMULATION_ANALYSIS_STATIC_SUMMARY",
  /*    */ "SIMULATION_ANALYSIS_STATIC_SIMULATED_FORWARD_PROBABILITIES" = "SIMULATION_ANALYSIS_STATIC_SIMULATED_FORWARD_PROBABILITIES",
  /*    */ "SIMULATION_ANALYSIS_STATIC_RETURNS" = "SIMULATION_ANALYSIS_STATIC_RETURNS",
  /*    */ "SIMULATION_ANALYSIS_STATIC_DATA_EXPLORER" = "SIMULATION_ANALYSIS_STATIC_DATA_EXPLORER",
  /*    */ "SIMULATION_ANALYSIS_STATIC_CORRELATIONS" = "SIMULATION_ANALYSIS_STATIC_CORRELATIONS",
  /**/ "SIMULATION_PRICE_DRIVEN" = "SIMULATION_PRICE_DRIVEN",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_CORRELATIONS" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_CORRELATIONS",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_DATA_EXPLORER" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_DATA_EXPLORER",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_DISTANCE_FROM_TREND" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_DISTANCE_FROM_TREND",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_RETURNS" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_RETURNS",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_SIMULATED_FORWARD_PROBABILITIES" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_SIMULATED_FORWARD_PROBABILITIES",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_SUMMARY" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_SUMMARY",
  /*    */ "SIMULATION_ANALYSIS_PRICE_DRIVEN_YIELDS" = "SIMULATION_ANALYSIS_PRICE_DRIVEN_YIELDS",
  /**/ "SIMULATION_AB_TEST" = "SIMULATION_AB_TEST",
  /*    */ "SIMULATION_ANALYSIS_AB_TEST_RETURNS" = "SIMULATION_ANALYSIS_AB_TEST_RETURNS",
  /*    */ "SIMULATION_ANALYSIS_AB_TEST_SIMULATED_FORWARD_PROBABILITIES" = "SIMULATION_ANALYSIS_AB_TEST_SIMULATED_FORWARD_PROBABILITIES",
  /*    */ "SIMULATION_ANALYSIS_AB_TEST_SUMMARY" = "SIMULATION_ANALYSIS_AB_TEST_SUMMARY",
  /*    */ "SIMULATION_ANALYSIS_AB_TEST_YIELDS" = "SIMULATION_ANALYSIS_AB_TEST_YIELDS",
  /**/ "SIMULATION_MODELS" = "SIMULATION_MODELS",
  /*    */ "SIMULATION_ANALYSIS_MODELS_MODELS" = "SIMULATION_ANALYSIS_MODELS_MODELS",
  /*    */ "SIMULATION_ANALYSIS_MODELS_BOUNDARY" = "SIMULATION_ANALYSIS_MODELS_BOUNDARY",
  /*    */ "SIMULATION_ANALYSIS_MODELS_BEHAVIOR" = "SIMULATION_ANALYSIS_MODELS_BEHAVIOR",
  /*    */ "SIMULATION_ANALYSIS_MODELS_INDEX_COMPARE" = "SIMULATION_ANALYSIS_MODELS_INDEX_COMPARE",
  /*    */ "SIMULATION_ANALYSIS_MODELS_HISTORY" = "SIMULATION_ANALYSIS_MODELS_HISTORY",
  /*    */ "SIMULATION_ANALYSIS_MODELS_RUN" = "SIMULATION_ANALYSIS_MODELS_RUN",
  /**/ "SIMULATION_ANALYSIS_RUN" = "SIMULATION_ANALYSIS_RUN",
  /**/ "SIMULATION_ANALYSIS_SIMULATION_RUN_SETTINGS" = "SIMULATION_ANALYSIS_SIMULATION_RUN_SETTINGS",
  /**/ "SIMULATION_ANALYSIS_SIMULATION_YIELD_CURVES" = "SIMULATION_ANALYSIS_SIMULATION_YIELD_CURVES",
  /**/ "SIMULATION_ANALYSIS_X_RAY" = "SIMULATION_ANALYSIS_X_RAY",
  /**/ "SIMULATION_ANALYSIS_DATA_EXPLORER_FILTER_LB" = "SIMULATION_ANALYSIS_DATA_EXPLORER_FILTER_LB",
  /**/ "PDF_SIMULATION_MODELS_MODELS_REPORT" = "PDF_SIMULATION_MODELS_MODELS_REPORT",

  "ASSET_CLASS_ANALYSIS" = "ASSET_CLASS_ANALYSIS",
  /**/ "ASSET_CLASS_ANALYSIS_DASHBOARD" = "ASSET_CLASS_ANALYSIS_DASHBOARD",
  /**/ "ASSET_CLASS_ANALYSIS_ANALYZE" = "ASSET_CLASS_ANALYSIS_ANALYZE",
  /*    */ "ASSET_CLASS_MONTHLY_REPORT_SUMMARY" = "ASSET_CLASS_MONTHLY_REPORT_SUMMARY",

  /*    */ "ASSET_CLASS_ANALYSIS_HISTORICAL_ANALYSIS" = "ASSET_CLASS_ANALYSIS_HISTORICAL_ANALYSIS",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_DISTANCE_FROM_TREND" = "ASSET_CLASS_MONTHLY_REPORT_DISTANCE_FROM_TREND",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_INDEX_COMPARE" = "ASSET_CLASS_MONTHLY_REPORT_INDEX_COMPARE",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_MULTI_PERIOD_RETURN" = "ASSET_CLASS_MONTHLY_REPORT_MULTI_PERIOD_RETURN",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_PERFORMANCE_RISK" = "ASSET_CLASS_MONTHLY_REPORT_PERFORMANCE_RISK",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_SECTOR_ANALYSIS" = "ASSET_CLASS_MONTHLY_REPORT_SECTOR_ANALYSIS",
  /*    */ "ASSET_CLASS_ANALYSIS_FORWARD_LOOKING_ANALYSIS" = "ASSET_CLASS_ANALYSIS_FORWARD_LOOKING_ANALYSIS",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_SIMULATED_FORWARD_PROBABILITY" = "ASSET_CLASS_MONTHLY_REPORT_SIMULATED_FORWARD_PROBABILITY",
  /*        */ "ASSET_CLASS_MONTHLY_REPORT_CORRELATIONS" = "ASSET_CLASS_MONTHLY_REPORT_CORRELATIONS",
  /**/ "PDF_SUMMARY_REPORT" = "PDF_SUMMARY_REPORT",
  /**/ "PDF_PERFORMANCE_RISK_REPORT" = "PDF_PERFORMANCE_RISK_REPORT",
  /**/ "PDF_MULTI_PERIOD_RETURN_REPORT" = "PDF_MULTI_PERIOD_RETURN_REPORT",
  /**/ "PDF_DISTANCE_FROM_TREND_REPORT" = "PDF_DISTANCE_FROM_TREND_REPORT",
  /**/ "PDF_INDEX_COMPARE_REPORT" = "PDF_INDEX_COMPARE_REPORT",
  /**/ "PDF_SECTOR_ANALYSIS_REPORT" = "PDF_SECTOR_ANALYSIS_REPORT",
  /**/ "PDF_SIMULATED_FORWARD_PROBABILITY_REPORT" = "PDF_SIMULATED_FORWARD_PROBABILITY_REPORT",

  "PORTFOLIO_ANALYSIS" = "PORTFOLIO_ANALYSIS",
  /**/ "PORTFOLIO_ANALYSIS_DASHBOARD" = "PORTFOLIO_ANALYSIS_DASHBOARD",
  /**/ "PORTFOLIO_ANALYSIS_EDIT_PORTFOLIO" = "PORTFOLIO_ANALYSIS_EDIT_PORTFOLIO",
  /*    */ "PORTFOLIO_ANALYSIS_ASSET_CLASS_SELECTION" = "PORTFOLIO_ANALYSIS_ASSET_CLASS_SELECTION",
  /*    */ "PORTFOLIO_ANALYSIS_CREATE_MODEL" = "PORTFOLIO_ANALYSIS_CREATE_MODEL",
  /*    */ "PORTFOLIO_ANALYSIS_OPTIMIZATION" = "PORTFOLIO_ANALYSIS_OPTIMIZATION",
  /*    */ "PORTFOLIO_ANALYSIS_EDIT_COMPARE" = "PORTFOLIO_ANALYSIS_EDIT_COMPARE",
  /*    */ "PORTFOLIO_ANALYSIS_ANALYZE" = "PORTFOLIO_ANALYSIS_ANALYZE",
  /**/ "PDF_PORTFOLIO_ANALYSIS_SUMMARY_REPORT" = "PDF_PORTFOLIO_ANALYSIS_SUMMARY_REPORT",
  /**/ "PDF_PORTFOLIO_ANALYSIS_PERFORMANCE_RISK_REPORT" = "PDF_PORTFOLIO_ANALYSIS_PERFORMANCE_RISK_REPORT",
  /**/ "PDF_PORTFOLIO_ANALYSIS_MULTI_PERIOD_RETURN_REPORT" = "PDF_PORTFOLIO_ANALYSIS_MULTI_PERIOD_RETURN_REPORT",
  /**/ "PDF_PORTFOLIO_ANALYSIS_SIMULATED_FORWARD_PROBABILITY_REPORT" = "PDF_PORTFOLIO_ANALYSIS_SIMULATED_FORWARD_PROBABILITY_REPORT",
  /**/ "PDF_PORTFOLIO_ANALYSIS_SCENARIO_ANALYSIS_REPORT" = "PDF_PORTFOLIO_ANALYSIS_SCENARIO_ANALYSIS_REPORT",
  /**/ "PDF_PORTFOLIO_ANALYSIS_SECTOR_ANALYSIS_REPORT" = "PDF_PORTFOLIO_ANALYSIS_SECTOR_ANALYSIS_REPORT",

  "ASSET_ALLOCATION" = "ASSET_ALLOCATION",
  /**/ "ASSET_ALLOCATION_DASHBOARD" = "ASSET_ALLOCATION_DASHBOARD",
  /**/ "ASSET_ALLOCATION_EDIT_PORTFOLIO_GROUP" = "ASSET_ALLOCATION_EDIT_PORTFOLIO_GROUP",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_ASSET_CLASS_SELECTION" = "ANALYZE_PORTFOLIO_GROUP_ASSET_CLASS_SELECTION",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_CREATE_ALLOCATIONS" = "ANALYZE_PORTFOLIO_GROUP_CREATE_ALLOCATIONS",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_EDIT_COMPARE" = "ANALYZE_PORTFOLIO_GROUP_EDIT_COMPARE",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_OPTIMIZATION" = "ANALYZE_PORTFOLIO_GROUP_OPTIMIZATION",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_ANALYZE" = "ANALYZE_PORTFOLIO_GROUP_ANALYZE",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_SELECTION" = "ANALYZE_PORTFOLIO_GROUP_SELECTION",
  /*    */ "ANALYZE_PORTFOLIO_GROUP_PUBLISH" = "ANALYZE_PORTFOLIO_GROUP_PUBLISH",
  /**/ "ASSET_ALLOCATION_VIEW_PORTFOLIO_GROUP" = "ASSET_ALLOCATION_VIEW_PORTFOLIO_GROUP",
  /*    */ "VIEW_PORTFOLIO_GROUP_SUMMARY" = "VIEW_PORTFOLIO_GROUP_SUMMARY",
  /*    */ "VIEW_PORTFOLIO_GROUP_ANALYZE" = "VIEW_PORTFOLIO_GROUP_ANALYZE",

  /**/ "PDF_ASSET_ALLOCATION_SUMMARY_REPORT" = "PDF_ASSET_ALLOCATION_SUMMARY_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_SUMMARY_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_SUMMARY_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_PERFORMANCE_RISK_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_PERFORMANCE_RISK_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_MULTI_PERIOD_RETURN_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_MULTI_PERIOD_RETURN_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_SIMULATED_FORWARD_PROBABILITIES_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_SIMULATED_FORWARD_PROBABILITIES_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_SCENARIO_ANALYSIS_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_SCENARIO_ANALYSIS_REPORT",
  /**/ "PDF_ASSET_ALLOCATION_MODULE_SECTOR_ANALYSIS_REPORT" = "PDF_ASSET_ALLOCATION_MODULE_SECTOR_ANALYSIS_REPORT",

  // deprecated
  /**/ "PDF_PORTFOLIO_GROUP_PUBLISH_REPORT" = "PDF_PORTFOLIO_GROUP_PUBLISH_REPORT",

  "PLANNING" = "PLANNING",
  /**/ "PLANNING_ADD_CLIENT" = "PLANNING_ADD_CLIENT",
  /**/ "PLANNING_CLIENT_LIST" = "PLANNING_CLIENT_LIST",
  /**/ "PLANNING_CLIENT_SUMMARY" = "PLANNING_CLIENT_SUMMARY",
  /**/ "PLANNING_PLAN_INPUT" = "PLANNING_PLAN_INPUT",
  /**/ "PLANNING_WORKBENCH" = "PLANNING_WORKBENCH",
  /*    */ "PLANNING_WORKBENCH_ALLOCATION_BY_ACCOUNT" = "PLANNING_WORKBENCH_ALLOCATION_BY_ACCOUNT",
  /*    */ "PLANNING_WORKBENCH_CAP_GAINS" = "PLANNING_WORKBENCH_CAP_GAINS",
  /*    */ "PLANNING_WORKBENCH_HOUSEHOLD_ALLOCATION" = "PLANNING_WORKBENCH_HOUSEHOLD_ALLOCATION",
  /*    */ "PLANNING_WORKBENCH_PLAN_RESULTS" = "PLANNING_WORKBENCH_PLAN_RESULTS",
  /*    */ "PLANNING_WORKBENCH_PUBLISH_PLAN" = "PLANNING_WORKBENCH_PUBLISH_PLAN",
  /*    */ "PLANNING_WORKBENCH_STRESS_TEST" = "PLANNING_WORKBENCH_STRESS_TEST",
  /**/ "PLANNING_PROGRESS_MONITORING" = "PLANNING_PROGRESS_MONITORING",
  /**/ "PDF_PLANNING_REPORT" = "PDF_PLANNING_REPORT",
  /**/ "PDF_ACTION_REPORT" = "PDF_ACTION_REPORT",

  "SETTINGS" = "SETTINGS",
  /**/ "SETTINGS_FIRM_SETTINGS" = "SETTINGS_FIRM_SETTINGS",
  /*    */ "SETTINGS_MANAGE_FIRM" = "SETTINGS_MANAGE_FIRM",
  /*    */ "SETTINGS_BILLING" = "SETTINGS_BILLING",
  /**/ "SETTINGS_ASSET_CLASS_SETTINGS" = "SETTINGS_ASSET_CLASS_SETTINGS",
  /**/ "SETTINGS_DISCLOSURES" = "SETTINGS_DISCLOSURES",
  /**/ "SETTINGS_NOTIFICATIONS" = "SETTINGS_NOTIFICATIONS",
  /**/ "SETTINGS_USER_PROFILE" = "SETTINGS_USER_PROFILE",
  /**/ "SETTINGS_BACK_END" = "SETTINGS_BACK_END",
}

export const useUserAccess = () => {
  const selfAuth = useCommonAuthSelfRetrieveQuery();
  const roles = useRoles();
  const modules = useCommonCmpasModuleListQuery();
  const pageTree = usePageTree();

  return useMemo(() => {
    const isLoading =
      selfAuth.isLoading ||
      roles.isLoading ||
      modules.isLoading ||
      pageTree.isLoading;

    const isCaravelUser = selfAuth.data?.firm?.id === CARAVEL_FIRM_ID;

    const isAdmin = roles.isAdminRole(selfAuth.data?.role);
    const role = roles.getRole(selfAuth.data?.role);

    const hasModuleSectionAccess = (code: CarModuleSectionCode) => {
      if (code === CarModuleSectionCode.SETTINGS_BACK_END && !isCaravelUser) {
        return false;
      }

      return (
        isLoading ||
        isAdmin ||
        !!(
          role?.is_active && pageTree.hasAccess(code, role?.module_access ?? [])
        )
      );
    };

    if (!isLoading) {
      const embeddedCodes = Object.values(CarModuleSectionCode) as string[];
      const pageCodes = pageTree.allItems.map((i) => i.code);

      const missingPages = embeddedCodes.filter((i) => !pageCodes.includes(i));
      if (missingPages.length > 0) {
        debugLog("Missing pages:\n", missingPages.join("\n"));
      }

      const redundantPages = pageCodes.filter(
        (i) => !embeddedCodes.includes(i),
      );
      if (redundantPages.length > 0) {
        debugLog("Redundant pages:\n", redundantPages.join("\n"));
      }
    }

    return {
      isLoading,
      hasModuleSectionAccess,
      isCaravelUser,
    };
  }, [selfAuth, roles, modules, pageTree]);
};

export type UseUserAccess = ReturnType<typeof useUserAccess>;
